import React, { Component } from 'react';
import {connect} from "react-redux";
import update from 'immutability-helper';
import {Button, Clearfix, Form, FormControl} from "react-bootstrap";
import * as UserActions from "../actions/UserActions";
import Loading from "../components/Loading";
import {LinkContainer} from "react-router-bootstrap";

class UserPage extends Component {
    constructor(){
        super();

        this.state = {
            changingName: false,
            form: {
                name: "",
            }
        }
    }

    changeName(event){
        event.preventDefault();

        this.setState({changingName: false})
        if(this.state.form.name){
            this.props.updateUser(this.props.user.id, {
                name: this.state.form.name
            })
        }
    }
    handleChange(event) {
        this.setState({
            form:
                update(this.state.form, {
                    [event.target.name]: {$set: event.target.value}
                })
        });
    }

    render() {
        const {team, user} = this.props;

        return this.props.user && (
            <div className="card">
                <div className="card-heading">
                    <h1 className="card-title">

                        <LinkContainer to="/cancel" className="pull-right">
                            <Button>Remove account</Button>
                        </LinkContainer>
                        {this.props.user.name}
                        <Loading right loading={this.props.users.updating} />
                        <Clearfix />
                    </h1>
                </div>
                <Form onSubmit={this.changeName.bind(this)}>
                    <table className="table table-striped" style={{marginBottom: 0}}>
                        <tbody>
                            <tr>
                                <th className="hidden-xs">Team</th>
                                <td>{team && team.name}</td>
                                <td></td>
                            </tr>
                            <tr>
                                <th className="hidden-xs">Username</th>
                                <td>{user.email}</td>
                                <td></td>
                            </tr>
                            <tr>
                                <th className="hidden-xs">Display name</th>
                                <td>
                                    {!this.state.changingName && user.name}
                                    {this.state.changingName && (
                                        <FormControl componentClass="input" name="name"  onChange={this.handleChange.bind(this)}
                                                 value={this.state.form.name || this.props.user.name}/>
                                    )}
                                </td>
                                <td>
                                    {!this.state.changingName && (<Button className="pull-right" onClick={() => this.setState({changingName: true})}>change</Button>)}
                                    {this.state.changingName && (<Button bsStyle="primary" type="submit" className="pull-right">save</Button>)}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </Form>
            </div>
        );
    }
}

export default connect(state => ({
    users: state.users,
    user: state.users.active,
    team: state.teams.active
}), dispatch => ({
    updateUser: (userId, data) => dispatch(UserActions.updateUser(userId, data))
}))(UserPage);


// WEBPACK FOOTER //
// ./src/pages/UserPage.js